import { WarningOutlined } from "@ant-design/icons";
import { DatePicker as AntdDatePicker, ConfigProvider } from "antd";
import localeEn from 'antd/es/date-picker/locale/en_US';
import localeTh from 'antd/es/date-picker/locale/th_TH';
import enUS from "antd/es/locale/en_US";
import thTh from "antd/es/locale/th_TH";
import cx from "classnames";
import { useField } from "formik";
import { isNil } from "lodash";
import get from 'lodash/get';
import { useTranslation } from "react-i18next";
import styles from "./DatePickerForm.module.css";

function DatePickerForm({
  label = "",
  name = "",
  placeholder = "",
  type = "text",
  size = "middle",
  className = "",
  required = false,
  disabled = false,
  format = "DD/MM/YYYY",
  max = null,
  min = null,
  onChange = () => { },
  disabledDate = () => { },
  defaultValue = null,
  readOnly = false,
  errors,
  touched
}) {
  const [field, meta, helpers] = useField(name);
  const { onBlur } = field;
  const { value } = meta;
  const { setValue } = helpers;
  const { t, i18n } = useTranslation();
  const hasError = get(errors, name)
  const handleChange = (date) => {
    setValue(date);
    onChange(date);
  };

  function localeFn() {
    if (i18n.language === 'en') {
      return localeEn
    } else {
      return {
        ...localeTh,
        lang: {
          ...localeTh.lang,
          yearFormat: "BBBB",
          dateFormat: "D/M/BBBB",
          cellYearFormat: "BBBB"
        }
      }
    }
  }
  const translatedError = i18n?.language === "th"
    ? `กรุณาเลือก ${label}`
    : `Please enter ${label?.toLowerCase?.()}`

  return (

    <div className={cx(styles.container, className)}>
      {label && (
        <label className={cx("label", styles.label)} htmlFor={name}>
          {label}
          {required && <span className="error">*</span>}
        </label>
      )}
      <ConfigProvider locale={i18n.language === 'en' ? enUS : thTh}>
        <AntdDatePicker
          id={name}
          locale={localeFn()}
          className={styles.input}
          name={name}
          placeholder={placeholder}
          type={type}
          readOnly={readOnly}
          value={value || defaultValue}
          onChange={handleChange}
          onBlur={onBlur}
          data-state={(touched && hasError) ? "error" : ""}
          status={(touched && hasError) ? "error" : ""}
          disabled={disabled}
          data-type={type}
          size={size}
          maxDate={max}
          minDate={min}
          format={i18n.language === 'en' ? format : format?.replace?.(/(Y)/g, "B")}
          disabledDate={disabledDate}
        />
      </ConfigProvider>
      {touched && hasError && (
        <span className={cx("error", styles.error)}>
          <WarningOutlined /> {!isNil(hasError) ? hasError : translatedError}
        </span>
      )}
    </div>
  );
}

export default DatePickerForm;
